module.exports = __webpack_public_path__ + "static/media/img_1.0197ef44.png";